import React, { useContext, useEffect, useState } from 'react';
import './Lots.css';
import { FirebaseContext } from '../../../context/firebase';
import Calendar from 'react-calendar';
import { CircularProgress, makeStyles } from '@material-ui/core';
import * as PROJECT_CODE from '../../../constants/projectCode';
import siteplan from '../../../assets/siteplan.jpg';
import ImageMapper from 'react-img-mapper';

function Lots({
	setLotList,
	setBuildingPriceSum,
	setLotPriceSum,
	setLotPrice,
}) {
	const { firebase } = useContext(FirebaseContext);
	const [mapCoords, setMapCoords] = useState({
		'name': 'my-map',
	});
	const [hoveredArea, setHoveredArea] = useState();

	const useStyles = makeStyles((theme) => ({}));

	const styles = useStyles();

	//setting up the map
	useEffect(() => {
		async function getData() {
			await firebase
				.database()
				.ref('/kavtek_clients/' + PROJECT_CODE.projectCode + '/lots')
				.once('value', (snapshot) => {
					var mapCoordObj;
					var areaArr = [];
					snapshot.forEach((lot) => {
						var mapCoordVal = lot.val().mapCoords;

						areaArr.push(mapCoordVal);

						var mapCoordChild = lot.child('mapCoords');

						console.log('mapCoordChild: ' + JSON.stringify(mapCoordChild));

						// mapCoordChild.forEach((child) => {
						// 	console.log('childdddd: ' + JSON.stringify(child));
						// });

						// console.log('mapCoordVal ' + JSON.stringify(mapCoordVal));

						mapCoordObj = {
							...mapCoords,
							areas: areaArr,
						};
					});

					// console.log('areaa: ' + areaArr);

					setMapCoords(mapCoordObj);
					// console.log('mapppp: ' + JSON.stringify(mapCoordObj));
				});
		}
		getData();
	}, []);

	const handleClickLot = (area) => {
		console.log(`${area.name} is clicked`);

		function capitalizeFirstLetter(string) {
			return string.charAt(0).toUpperCase() + string.slice(1);
		}

		firebase.auth().onAuthStateChanged(function (user) {
			if (user) {
				var buildingArr = [];
				var priceDetailArr = [];

				var buildingDetails;
				var lotSelected = area.name;
				firebase
					.database()
					.ref(
						'/kavtek_clients/' +
							PROJECT_CODE.projectCode +
							'/lots/' +
							lotSelected
					)
					.on('value', (snapshot) => {
						var availability = snapshot.val().available;

						var buildingRef = snapshot.child('buildings');
						console.log('buildingRef: ' + JSON.stringify(buildingRef));
						buildingRef.forEach((snap) => {
							function numberWithCommas(x) {
								return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
							}

							snap.forEach((building) => {
								buildingDetails = {
									name: capitalizeFirstLetter(building.key),
									buildingLot: lotSelected,
									price: building.val().priceList,
									sqft: building.val().sqft,
									buildingPrice: numberWithCommas(building.val().buildingPrice),
									soldout: building.val().soldout,
									available: availability,
								};

								buildingArr.push(buildingDetails);
							});
						});

						console.log('buildingDetails: ' + JSON.stringify(buildingDetails));
						setLotList(buildingArr);
					});

				firebase
					.database()
					.ref(
						'/kavtek_clients/' +
							PROJECT_CODE.projectCode +
							'/lots/' +
							lotSelected
					)
					.on('value', (snapshot) => {
						var lotPrice = snapshot.val().lotPrice;

						setLotPrice(lotPrice);
					});

				var buildingPriceList = [];
				var lotPriceList = [];
				firebase
					.database()
					.ref('/kavtek_clients/' + PROJECT_CODE.projectCode + '/buildingInfo/')
					.on('value', (snapshot) => {
						snapshot.forEach((snap) => {
							var priceList = snap.val().buildingPrice;
							buildingPriceList.push(priceList);
							var priceListRef = snap.child('priceList');

							priceListRef.forEach((priceLot) => {
								var lotPrice = priceLot.val().price;
								lotPriceList.push(lotPrice);
							});
						});

						var lotSum = lotPriceList.reduce(function (a, b) {
							return a + b;
						}, 0);

						setLotPriceSum(lotSum);

						var sum = buildingPriceList.reduce(function (a, b) {
							return a + b;
						}, 0);

						console.log('this is the sum ' + sum);

						setBuildingPriceSum(sum);
					});
			}
		});
	};

	const enterArea = (area) => {
		setHoveredArea(area);
	};

	return (
		<div className='lots_wrapper'>
			<div className='siteplan_wrapper doc_card'>
				<div className='card_title'>Site Plan</div>
				{!mapCoords.areas ? (
					<div className={styles.mapImage}>
						<CircularProgress />
					</div>
				) : (
					<ImageMapper
						src={siteplan}
						map={mapCoords}
						stayHighlighted={true}
						areaKeyName={mapCoords.areas.id}
						fillColor={'rgba(71, 131, 230, 0.70)'}
						strokeColor={'rgba(71, 131, 230)'}
						onMouseEnter={(area) => {
							enterArea(area);
						}}
						onClick={(area) => {
							handleClickLot(area);
						}}
					/>
				)}
			</div>
		</div>
	);
}

export default Lots;
